import React from "react";

export default function Loading() {
  return (
    <div className="mt-40">
      <div className="loader">
        <div className="ball"></div>
        <div className="ball"></div>
        <div className="ball"></div>
      </div>
    </div>
  );
}
